module.exports = __webpack_public_path__ + "cd51246168c29108034ddbebdb484103.fbx";